module.exports = "./img/02cff6a4a2c4add7fc1210d2f8d1a2b0.png";